// extracted by mini-css-extract-plugin
export default {"wrap":"cq-z","logoContainer":"dq-z","brandImg":"eq-z","logoImg":"fq-z","logoButton":"gq-z"};